import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { DataInterop } from "@silvertours/front-shared";
import { useMessages, useTranslations } from "next-intl";
import { useHost } from "../_legacy/Host";
var AutoRentalData = function() {
    var messages = useMessages();
    var days = Object.keys(messages.features.documentLegacy.siteInformation.openingHoursSpecification.dayOfWeek);
    var formatImage = useHost().formatImage;
    var siteInfo = useTranslations("features.documentLegacy.siteInformation");
    var openingHours = days.map(function(day) {
        return siteInfo("openingHoursSpecification.dayOfWeek.".concat(day));
    }).filter(function(translation) {
        return !translation.startsWith("features");
    });
    var openingHoursSpecification = {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: openingHours,
        opens: siteInfo("openingHoursSpecification.opens"),
        closes: siteInfo("openingHoursSpecification.closes")
    };
    var address = {
        "@type": "PostalAddress",
        streetAddress: siteInfo("address.streetAddress"),
        postalCode: siteInfo("address.postalCode"),
        addressLocality: siteInfo("address.addressLocality"),
        addressCountry: siteInfo("address.addressCountry")
    };
    return /*#__PURE__*/ _jsx(DataInterop.StructuredData, {
        type: "AutoRental",
        data: {
            name: siteInfo("name"),
            image: formatImage(siteInfo("image")),
            telephone: siteInfo("telephone"),
            address: address,
            openingHoursSpecification: openingHoursSpecification
        },
        includeContext: true
    });
};
export { AutoRentalData };
